<script lang="ts">
    class ServiziTrasporto {
        navettaAziendale: boolean = undefined;
        navettaAziendaleNote: string = "";
        autoAziendali: boolean = undefined;
        autoAziendaliNote: string = "";
        motoBikeMonAziendali: boolean = undefined;
        motoBikeMonAziendaliNote: string = "";
        carSharingAziendale: boolean = undefined;
        carSharingAziendaleNote: string = "";
        piattaformaCarPooling: boolean = undefined;
        piattaformaCarPoolingNote: string = "";

        constructor(init?: ServiziTrasporto) {
            Object.assign(this, init);
        }
    }

    export let data: ServiziTrasporto = new ServiziTrasporto();

    const properties = [
        { name: "Navetta aziendale", key: "navettaAziendale", noteKey: "navettaAziendaleNote", type: "boolean" },
        { name: "Automobili aziendali", key: "autoAziendali", noteKey: "autoAziendaliNote", type: "boolean" },
        { name: "Moto/biciclette/monopattini aziendali", key: "motoBikeMonAziendali", noteKey: "motoBikeMonAziendaliNote", type: "boolean" },
        { name: "Car sharing aziendale", key: "carSharingAziendale", noteKey: "carSharingAziendaleNote", type: "boolean" },
        { name: "Piattaforma di car pooling", key: "piattaformaCarPooling", noteKey: "piattaformaCarPoolingNote", type: "boolean" },
    ];

    function isAnyFieldSet(): boolean {
        return properties.some((property) => data?.[property?.key] !== undefined);
    }
</script>

<table class="w-full text-xs border border-black table-fixed">
    <thead>
        <tr>
            <th class="border border-black">Voce</th>
            <th class="border border-black">Valore</th>
            <th class="border border-black">Note</th>
        </tr>
    </thead>
    <tbody>
        {#each properties as property}
            <tr>
                <td class="text-center border border-black">{property?.name}</td>
                <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                    {data?.[property?.key] !== undefined ? (data?.[property?.key] ? "Sì" : "No") : '-'}
                </td>
                <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                    {data?.[property?.key] && data?.[property?.noteKey] ? data?.[property?.noteKey] : '-'}
                </td>
            </tr>
        {/each}
    </tbody>
</table>